import axios from "axios";

import { getUserCredentials } from "../utils/common";
import { API_URL, API_URL_AUTH } from "../utils/Constant";

export const getUserConfiguration = async (userOrParams = "", additionalParams = {}) => {
  try {
    const user_payload = getUserCredentials()?.user_payload;
    let params = {};

    if (typeof userOrParams === "string") {
      if (userOrParams) {
        params.user = userOrParams;
      }
    } else if (userOrParams && typeof userOrParams === "object") {
      params = { ...userOrParams };
    }

    if (additionalParams && typeof additionalParams === "object") {
      params = { ...params, ...additionalParams };
    }

    if (user_payload) {
      params.user_payload = user_payload;
    }

    const response = await axios.get(
      `${API_URL}/supportloginconfig/`,
      { params },
    );
    return response.data.result;
  } catch (error) {
    // eslint-disable-next-line
    console.error("Error fetching user configuration:", error);
    throw error;
  }
};

export const getAllCompanies = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/getcompanieslist/`,
    );
    return response.data.result || [];
  } catch (error) {
    // eslint-disable-next-line
    console.error("Error fetching user configuration:", error);
    throw error;
  }
};

export const manageUserConfiguration = async (payload) => {
  try {
    const user_payload = getUserCredentials()?.user_payload;
    const response = await axios.post(`${API_URL}/supportloginconfig/`, { ...payload, user_payload });
    return response.data;
  } catch (error) {
    // eslint-disable-next-line
    console.error("Error managing user configuration:", error);
    throw error;
  }
};

export const updateCompanyAccess = async ({ user, company_access }) => {
  try {
    const user_payload = getUserCredentials()?.user_payload;
    const response = await axios.patch(`${API_URL}/supportloginconfig/`, {
      user,
      company_access,
      user_payload,
    });
    return response.data;
  } catch (error) {
    // eslint-disable-next-line
    console.error("Error updating company access:", error);
    throw error;
  }
};

export const deleteSupportUser = async (user) => {
  try {
    const user_payload = getUserCredentials()?.user_payload;
    const response = await axios.delete(
      `${API_URL}/supportloginconfig/`,
      {
        data: {
          user,
          user_payload,
        },
      },
    );
    return response.data;
  } catch (error) {
    // eslint-disable-next-line
    console.error("Error deleting support user:", error);
    throw error;
  }
};

/**
 * Check if a user exists by email
 * @param {string} email - User email address
 * @param {string} companyName - Optional company name
 * @returns {Promise<Object>} { success, message, status, user_name, phone_number, user_title, firebase_exist_status, userNotFound }
 */
export const checkUser = async (email, companyName) => {
  try {
    const user_payload = getUserCredentials()?.user_payload;
    const params = { email };
    if (companyName) {
      params.company_name = companyName;
    }
    if (user_payload) {
      params.disableInterceptor = true;
    }

    const response = await axios.get(
      `${API_URL}/checkuser/`,
      { params: { ...params, user_payload } },
    );

    const {
      status, user_name, user_contact, user_title, firebase_exist_status,
    } = response.data.result || {};

    return {
      success: response.data.message === "Success",
      message: response.data.message,
      status,
      user_name,
      phone_number: user_contact,
      user_title,
      firebase_exist_status,
    };
  } catch (error) {
    const message = error.response?.data?.message || "Something went wrong.";
    return {
      success: false,
      message,
      userNotFound: message === "User not found" || message.toLowerCase().includes("not found"),
    };
  }
};

/**
 * Send forgot password email to user
 * @param {string} email - User email address
 * @returns {Promise<Object>} { success, message }
 */
export const sendForgotPasswordEmail = async (email) => {
  try {
    const response = await axios.post(
      `${API_URL_AUTH}/forgotpassword/`,
      { email },
    );
    const { message } = response.data;
    if (message === "Password reset email sent") {
      return { success: true, message };
    }
    return { success: false, message: message || "Something went wrong" };
  } catch (e) {
    const message = e.response?.data?.message ?? e.message ?? "Something went wrong";
    return { success: false, message };
  }
};
